module.exports = __webpack_public_path__ + "img/icon17.654ac317.654ac317.svg";